import React, { Fragment } from 'react';
import Footer from '../../components/Footer/Footer';

const ComponentWithoutHeader = ({ component: Component, ...rest }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
      <div style={{ flex: '1 0 auto' }}>
        <Component {...rest} />
      </div>
      <Footer />
    </div>
  );
};

export default ComponentWithoutHeader;